import gamesApi from '@/src/services/games'
import { store } from '@/src/store/store'

// Helper functions START
const string = (value: unknown) => `${value}`
const number = (value: string | null) => value && Number.parseInt(value)
const boolean = (value: unknown) =>
  ['1', 'true', 'on'].includes(`${value}`.toLowerCase())
export const hasAltenarWSDK = () => window.altenarWSDK !== undefined
// Helper functions END

// Altenar params START
const ALTENAR_PARAMS_TRANSFORMERS = {
  page: (params: URLSearchParams) => string(params.get('page')),
  betId: (params: URLSearchParams) => string(params.get('betId')),
  categoryIds: (params: URLSearchParams) =>
    params.getAll('categoryIds').map(number),
  championshipIds: (params: URLSearchParams) =>
    params.getAll('championshipIds').map(number),
  clearBetSlip: (params: URLSearchParams) =>
    boolean(params.get('clearBetSlip')),
  couponType: (params: URLSearchParams) => number(params.get('couponType')),
  date: (params: URLSearchParams) => string(params.get('date')),
  eventId: (params: URLSearchParams) => number(params.get('eventId')),
  horseRaceId: (params: URLSearchParams) => number(params.get('horseRaceId')),
  maxOdd: (params: URLSearchParams) => number(params.get('maxOdd')),
  oddIds: (params: URLSearchParams) => params.getAll('oddIds').map(number),
  reservationCode: (params: URLSearchParams) =>
    string(params.get('reservationCode')),
  shareCode: (params: URLSearchParams) => string(params.get('shareCode')),
  sportId: (params: URLSearchParams) => number(params.get('sportId')),
  virtualSportId: (params: URLSearchParams) =>
    number(params.get('virtualSportId')),
}

type AltenarParams = keyof typeof ALTENAR_PARAMS_TRANSFORMERS

const isAltenarParam = (key: string): key is AltenarParams =>
  key in ALTENAR_PARAMS_TRANSFORMERS

export const getAltenarParamsFromURL = (searchParams: URLSearchParams) => {
  const keys = new Set(searchParams.keys())

  const params: Record<string, unknown> = {}

  keys.forEach((key) => {
    if (isAltenarParam(key)) {
      params[key] = ALTENAR_PARAMS_TRANSFORMERS[key](searchParams)
    }
  })

  return params
}
// Altenar params END

// Altenar init START
export const initAltenar = (initParams: {
  integration: unknown
  lang?: string
  themeName?: string
  token: string
}) => {
  window.altenarWSDK.init({
    integration: initParams.integration,
    culture: initParams.lang || 'en-GB',
    themeName: initParams.themeName || 'light',
    token: initParams.token,
  })

  const url = new URL(window.location.href)
  const params = getAltenarParamsFromURL(url.searchParams)

  return window.altenarWSDK.addSportsBook({
    props: {
      ...params,
      page: params.page ?? 'overview',
      routerType: 'memory',
      // write content data to URL search params
      onBetPlacement: () => {
        store.dispatch(gamesApi.util.invalidateTags(['GameTransactions']))
      },
      onRouteChange: (data: URLSearchParams) => {
        const url = new URL(window.location.href)
        url.search = new URLSearchParams(data).toString()
        window.history.pushState(null, '', url)
      },
      onGoBack: () => {
        window.history.back()
      },
    },
    container: document.getElementById('altenarsportsbook'),
  })
}
